import { Card } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import FormatBoolean from "go-core/components/Formatters/FormatBoolean";
import { ProductCatalogApi } from "../../../../../../../../../services/Api/Admin/adminTypes";

interface Props {
	catalog: ProductCatalogApi;
}

const ProductCatalogPreview = ({ catalog }: Props) => {
	const { t } = useTranslation("admin");

	return (
		<>
			{catalog.applications.map((app, index) => {
				return (
					<Card key={index} className={"mb-3"}>
						<Card.Body>
							<h5>{app.family_id}</h5>
							<h6>
								{t("lib:common.word.name")}: {app.name}
							</h6>
							<h6>
								{t("lib:common.word.description")}: {app.description}
							</h6>
							<h6>
								{t("modules.tool.field.priority.title")}: {app.priority}
							</h6>
							<div className={"table-responsive"}>
								<table className={"table table-form"}>
									<thead>
										<tr>
											<th className={"action"} />
											<th>
												Plan_Id(
												{t("lib:common.word.name")})
											</th>
											<th>{t("modules.tool.field.priority.title")}</th>
											<th>Price_Id</th>
											<th>{t("modules.tool.field.period.title")}</th>
											<th>{t("lib:common.word.type")}</th>
											<th>Admin</th>
											<th>{t("modules.tool.field.additions.title")}</th>
											<th className={"action"} />
										</tr>
									</thead>
									<tbody>
										{app.plans.map((plan, subIndex) => {
											return (
												<tr key={subIndex}>
													<td className={"action"} />
													<td>{`${plan.plan_id} (${plan.name})`}</td>
													<td>{plan.priority}</td>
													<td>{plan.price_id}</td>
													<td>{plan.billing_period}</td>
													<td>{plan.subscription_type}</td>
													<td>
														<FormatBoolean value={plan.admin_only} />
													</td>
													<td style={{ whiteSpace: "nowrap" }}>
														<div className={"d-flex flex-column"}>
															{plan.addons.map((addon, addonIndex) => {
																return (
																	<span key={addonIndex}>
																		<strong>Price ID:</strong> {addon.price_id}
																		<br /> <strong>Addon ID: </strong>
																		{addon.addon_id}
																		<br />{" "}
																		<strong>{t("lib:common.word.name")}: </strong>
																		{addon.name}
																		<br />{" "}
																		<strong>
																			{t("lib:common.word.description")}:{" "}
																		</strong>
																		{addon.description}
																		<br />{" "}
																		<strong>
																			{t("modules.tool.field.priority.title")}:{" "}
																		</strong>
																		{addon.priority}
																		<br />{" "}
																		<strong>
																			{t("modules.tool.field.required.title")}:{" "}
																		</strong>
																		{addon.requirement}
																		<br />{" "}
																		<strong>{t("common.word.amount")}: </strong>
																		{addon.quantity}
																		<br />{" "}
																		<strong>{t("lib:common.word.type")}: </strong>
																		{addon.value_type}
																		{addonIndex !== plan.addons.length - 1 && (
																			<hr />
																		)}
																	</span>
																);
															})}
														</div>
													</td>
													<td className={"action"} />
												</tr>
											);
										})}
									</tbody>
								</table>
							</div>
						</Card.Body>
					</Card>
				);
			})}
		</>
	);
};
export default ProductCatalogPreview;
